import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { adminApi } from '../../lib/adminApi';

export default function AdminSearchInsights() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi('/api/admin/search-logs')
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Search Insights" subtitle="See what visitors are searching for and where content gaps exist.">
      {error && <div className="mb-4 rounded-xl border border-red-200 bg-red-50 p-4 text-sm font-bold text-red-700">{error}</div>}
      {loading ? <div className="rounded-2xl bg-white p-6 font-bold text-slate-600 shadow-sm">Loading search insights...</div> : (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <table className="min-w-full divide-y divide-slate-200 text-sm">
            <thead className="bg-slate-50 text-left text-xs font-black uppercase tracking-wider text-slate-500">
              <tr><th className="px-5 py-4">Query</th><th className="px-5 py-4">Type</th><th className="px-5 py-4">Results</th><th className="px-5 py-4">Searches</th><th className="px-5 py-4">Last Search</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((item, index) => (
                <tr key={`${item.query}-${index}`}>
                  <td className="px-5 py-4 font-black text-slate-950">{item.query}</td>
                  <td className="px-5 py-4 text-slate-600">{item.selected_type}</td>
                  <td className="px-5 py-4 text-slate-600">{item.result_count}</td>
                  <td className="px-5 py-4 text-slate-600">{item.searches}</td>
                  <td className="px-5 py-4 text-slate-600">{item.last_searched_at || '-'}</td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan="5" className="px-5 py-10 text-center font-bold text-slate-500">No search logs yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}
